<template>
  <hic-dialog :close-on-click-modal="false" :visible="visible" append-to-body title="辅助录入详情" @close="cancel">
    <el-descriptions title="" :column="3">
      <el-descriptions-item label="名称 ">{{ value.name }}</el-descriptions-item>
      <el-descriptions-item label="分类目录 ">{{ value.category | dictText("MrCategory") }}</el-descriptions-item>
      <el-descriptions-item label="性别限制 ">{{ value.gender }}</el-descriptions-item>
      <el-descriptions-item label="应用领域 ">{{ value.scope }}</el-descriptions-item>
      <el-descriptions-item label="应用范围 ">{{ value.mrRange }}</el-descriptions-item>
      <el-descriptions-item label="排序 ">{{ value.seqNo }}</el-descriptions-item>
      <el-descriptions-item label="关键字 " :span="3" :labelStyle="{ 'white-space': 'nowrap' }">{{ value.keyword }}</el-descriptions-item>
      <el-descriptions-item label="内容 " :span="3" :labelStyle="{ 'white-space': 'nowrap' }">
        <div v-html="infoFilter(value.content)"></div>
      </el-descriptions-item>
      <el-descriptions-item label="备注 " :span="3" :labelStyle="{ 'white-space': 'nowrap' }">{{ value.memo }}</el-descriptions-item>
    </el-descriptions>
  </hic-dialog>
</template>
<script>
  export default {
    components: {},
    props: {
      visible: Boolean,
      value: Object,
    },
    methods: {
      infoFilter(v) {
        let r = v ? v.replace(/[\n\r]/g, "<br/>") : "";
        return r;
      },
      cancel() {
        this.$emit("update:visible", false);
      },
    },
  };
</script>
